export const SHOW_AVAILABLE_DESKTOP_UPDATE_BANNER =
  'SHOW_AVAILABLE_DESKTOP_UPDATE_BANNER';

export function showAvailableDesktopUpdateBanner() {
  return {
    type: SHOW_AVAILABLE_DESKTOP_UPDATE_BANNER,
  };
}
